// extracted by mini-css-extract-plugin
export var actuItem = "notifications-module--actu-item--e7415";
export var notifItem = "notifications-module--notif-item--33966";
export var notificationCategorie = "notifications-module--notification-categorie--4ca54";
export var notificationDate = "notifications-module--notification-date--c8fb9";
export var notificationInfos = "notifications-module--notification-infos--b9c40";
export var notificationResume = "notifications-module--notification-resume--88b48";
export var notificationTitle = "notifications-module--notification-title--fed14";
export var notifsItemsContainer = "notifications-module--notifs-items-container--2f0a0";